import { render, staticRenderFns } from "./UploadFilePanel.vue?vue&type=template&id=7940f04c&scoped=true"
import script from "./UploadFilePanel.vue?vue&type=script&lang=js"
export * from "./UploadFilePanel.vue?vue&type=script&lang=js"
import style0 from "./UploadFilePanel.vue?vue&type=style&index=0&id=7940f04c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7940f04c",
  null
  
)

export default component.exports